"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightConfig = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const ColumnsBlock_1 = require("../../../ColumnsBlock");
const From_1 = require("../../../Form/Field/Date/From");
const DateRange_1 = require("../../../Form/Field/DateRange");
const legacy_1 = require("../../../Form/Field/Select/legacy");
class FlightConfig extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = this.getInitState();
        this.handleFlightMainAirportFromChange = (event) => {
            const flightAirport = event.target.value || '';
            const updatedFlightAirports = {
                ...this.props.flightMainAirports,
                from: this.state.airportFromByCodeMap[flightAirport],
                to: undefined,
            };
            const mainAirportsToList = this.getAirportListByCode(updatedFlightAirports.from.code);
            this.setState({
                flightMainAirportFrom: flightAirport,
                flightMainAirportTo: '',
                airportToListNames: this.getAirportListNames(mainAirportsToList),
                airportToByCodeMap: this.getAirportByCodeMap(mainAirportsToList),
            }, () => this.props.onFlightMainAirportsChange(updatedFlightAirports));
        };
        this.handleFlightMainAirportToChange = (event) => {
            const flightAirport = event.target.value || '';
            const updatedFlightAirports = {
                ...this.props.flightMainAirports,
                to: this.state.airportToByCodeMap[flightAirport],
            };
            this.setState({
                flightMainAirportTo: flightAirport,
            }, () => this.props.onFlightMainAirportsChange(updatedFlightAirports));
        };
        this.handleFlightOtherAirportFromChange = (event) => {
            const flightAirport = event.target.value || '';
            const updatedFlightAirports = {
                ...this.props.flightOtherAirports,
                from: this.state.otherAirportFromByCodeMap[flightAirport],
            };
            const otherAirportsToList = this.getAirportListByCode(updatedFlightAirports.from.code);
            this.setState({
                flightOtherAirportFrom: flightAirport,
                otherAirportToListNames: this.getAirportListNames(otherAirportsToList),
                otherAirportToByCodeMap: this.getAirportByCodeMap(otherAirportsToList),
            }, () => this.props.onFlightOtherAirportsChange(updatedFlightAirports));
        };
        this.handleFlightOtherAirportToChange = (event) => {
            const flightAirport = event.target.value || '';
            const updatedFlightAirports = {
                ...this.props.flightOtherAirports,
                to: this.state.otherAirportToByCodeMap[flightAirport],
            };
            this.setState({
                flightOtherAirportTo: flightAirport,
            }, () => this.props.onFlightOtherAirportsChange(updatedFlightAirports));
        };
    }
    static dateOptions() {
        return {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour12: false,
        };
    }
    getInitState() {
        var _a, _b, _c, _d;
        return {
            airportFromListNames: this.getAirportListNames(this.props.airportList),
            airportFromByCodeMap: this.getAirportByCodeMap(this.props.airportList),
            airportToListNames: this.getAirportListNames(this.props.airportList),
            airportToByCodeMap: this.getAirportByCodeMap(this.props.airportList),
            otherAirportFromListNames: this.getAirportListNames(this.props.airportList),
            otherAirportFromByCodeMap: this.getAirportByCodeMap(this.props.airportList),
            otherAirportToListNames: this.getAirportListNames(this.props.airportList),
            otherAirportToByCodeMap: this.getAirportByCodeMap(this.props.airportList),
            flightMainAirportFrom: ((_a = this.props.flightMainAirports.from) === null || _a === void 0 ? void 0 : _a.code) || '',
            flightMainAirportTo: ((_b = this.props.flightMainAirports.to) === null || _b === void 0 ? void 0 : _b.code) || '',
            flightOtherAirportFrom: ((_c = this.props.flightOtherAirports.from) === null || _c === void 0 ? void 0 : _c.code) || '',
            flightOtherAirportTo: ((_d = this.props.flightOtherAirports.to) === null || _d === void 0 ? void 0 : _d.code) || '',
        };
    }
    getAirportListByCode(code) {
        const codeMap = this.props.airportsAvailabilityMap[code] || [];
        return this.props.airportList.filter(airport => !!codeMap.find(x => x === airport.code));
    }
    getAirportByCodeMap(airportList) {
        const airportCodes = Object.keys(this.props.airportsAvailabilityMap);
        return airportList.reduce((acc, airport) => {
            if (!airportCodes.includes(airport.code))
                return acc;
            return {
                ...acc,
                ...{ [airport.code]: airport },
            };
        }, {});
    }
    getAirportListNames(airportList) {
        const airportCodes = Object.keys(this.props.airportsAvailabilityMap);
        return airportList
            .map((airport) => {
            return {
                name: airport.name && Object.keys(airport.name).includes(this.props.intl.locale)
                    ? airport.name[this.props.intl.locale]
                    : airport.code,
                value: airport.code,
            };
        })
            .filter(selectItem => airportCodes.includes(selectItem.value));
    }
    prepareStringOrDate(value) {
        const isDateFromValid = (0, moment_1.default)(value, dateTimeFormat_1.DATE_FORMAT, true).isValid();
        return isDateFromValid ? (0, moment_1.default)(value, dateTimeFormat_1.DATE_FORMAT).toDate() : undefined;
    }
    componentDidUpdate(prevProps) {
        var _a, _b;
        const flightMainAirportsTo = this.props.flightMainAirports.to;
        const flightMainAirportsFrom = this.props.flightMainAirports.from;
        if (flightMainAirportsTo && flightMainAirportsTo.code !== this.state.flightMainAirportTo
            || flightMainAirportsFrom && flightMainAirportsFrom.code !== this.state.flightMainAirportFrom) {
            this.setState({
                flightMainAirportTo: (_a = flightMainAirportsTo === null || flightMainAirportsTo === void 0 ? void 0 : flightMainAirportsTo.code) !== null && _a !== void 0 ? _a : '',
                flightMainAirportFrom: (_b = flightMainAirportsFrom === null || flightMainAirportsFrom === void 0 ? void 0 : flightMainAirportsFrom.code) !== null && _b !== void 0 ? _b : '',
            });
            this.updateToLists();
        }
        if (!(0, isEqual_1.default)(this.props.airportsAvailabilityMap, prevProps.airportsAvailabilityMap)) {
            this.setState({
                airportFromListNames: this.getAirportListNames(this.props.airportList),
                airportFromByCodeMap: this.getAirportByCodeMap(this.props.airportList),
                otherAirportFromListNames: this.getAirportListNames(this.props.airportList),
                otherAirportFromByCodeMap: this.getAirportByCodeMap(this.props.airportList),
            });
            this.updateToLists();
        }
        if (!(0, isEqual_1.default)(this.props.airportList, prevProps.airportList)) {
            this.setState({
                airportFromListNames: this.getAirportListNames(this.props.airportList),
                airportFromByCodeMap: this.getAirportByCodeMap(this.props.airportList),
                otherAirportFromListNames: this.getAirportListNames(this.props.airportList),
                otherAirportFromByCodeMap: this.getAirportByCodeMap(this.props.airportList),
                airportToListNames: this.getAirportListNames(this.props.airportList),
                airportToByCodeMap: this.getAirportByCodeMap(this.props.airportList),
                otherAirportToListNames: this.getAirportListNames(this.props.airportList),
                otherAirportToByCodeMap: this.getAirportByCodeMap(this.props.airportList),
            });
            if (this.props.flightMainAirports.from) {
                this.updateToLists();
            }
        }
    }
    updateToLists() {
        var _a, _b;
        const mainAirportsFromCode = (_a = this.props.flightMainAirports.from) === null || _a === void 0 ? void 0 : _a.code;
        const mainAirportsToList = mainAirportsFromCode
            ? this.getAirportListByCode(mainAirportsFromCode)
            : this.props.airportList;
        const otherAirportsFromCode = (_b = this.props.flightOtherAirports.from) === null || _b === void 0 ? void 0 : _b.code;
        const otherAirportsToList = otherAirportsFromCode
            ? this.getAirportListByCode(otherAirportsFromCode)
            : this.props.airportList;
        this.setState({
            airportToListNames: this.getAirportListNames(mainAirportsToList),
            airportToByCodeMap: this.getAirportByCodeMap(mainAirportsToList),
            otherAirportToListNames: this.getAirportListNames(otherAirportsToList),
            otherAirportToByCodeMap: this.getAirportByCodeMap(otherAirportsToList),
        });
    }
    render() {
        const { travelType, dateRange, onDateRangeChange, } = this.props;
        const { airportFromListNames, airportToListNames, otherAirportFromListNames, otherAirportToListNames, flightMainAirportFrom, flightMainAirportTo, flightOtherAirportFrom, flightOtherAirportTo, } = this.state;
        return (react_1.default.createElement("div", { className: 'block' },
            react_1.default.createElement(ColumnsBlock_1.ColumnsBlock, { modificators: ['travel-dates'] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: 'form-fields-together form-padding-bottom' },
                        react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { items: airportFromListNames, withBadge: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/From:label', defaultMessage: 'From' }), onChange: this.handleFlightMainAirportFromChange, placeholder: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/From:placeholder', defaultMessage: 'select ...' }), value: flightMainAirportFrom }),
                        react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { items: airportToListNames, withBadge: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/To:label', defaultMessage: 'To' }), onChange: this.handleFlightMainAirportToChange, placeholder: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/To:placeholder', defaultMessage: 'select ...' }), value: flightMainAirportTo })),
                    travelType === 'other-return' && (react_1.default.createElement("div", { className: 'form-fields-together' },
                        react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { items: otherAirportFromListNames, withBadge: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/OtherFrom:label', defaultMessage: 'From Other' }), onChange: this.handleFlightOtherAirportFromChange, placeholder: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/OtherFrom:placeholder', defaultMessage: 'select ...' }), value: flightOtherAirportFrom }),
                        react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { items: otherAirportToListNames, withBadge: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/OtherTo:label', defaultMessage: 'To Other' }), onChange: this.handleFlightOtherAirportToChange, placeholder: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/OtherTo:placeholder', defaultMessage: 'select ...' }), value: flightOtherAirportTo })))),
                react_1.default.createElement("div", null,
                    (travelType === 'return' || travelType === 'other-return') && (react_1.default.createElement(DateRange_1.FormFieldDateRange, { fromField: {
                            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/Departing:label', defaultMessage: 'Departing' })),
                            setValue: (value) => onDateRangeChange('from', value),
                            value: dateRange.from,
                        }, toField: {
                            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/Returning:label', defaultMessage: 'Returning' })),
                            setValue: (value) => onDateRangeChange('to', value),
                            value: dateRange.to,
                        }, restrictions: {
                            disablePastDays: true,
                            pastYearsCount: dateTime_1.bookingPastYearsCount,
                            nextYearsCount: dateTime_1.bookingNextYearsCount,
                        } })),
                    travelType === 'one-way' && (react_1.default.createElement(From_1.FormFieldFromDate, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightConfig/Departing:label', defaultMessage: 'Departing' }), setValue: (value) => {
                            onDateRangeChange('from', value);
                        }, value: dateRange.from, restrictions: {
                            disablePastDays: true,
                            pastYearsCount: dateTime_1.bookingPastYearsCount,
                            nextYearsCount: dateTime_1.bookingNextYearsCount,
                        } }))))));
    }
}
FlightConfig.defaultProps = {
    onDateRangeChange: () => {
    },
    onFlightMainAirportsChange: () => {
    },
    onFlightOtherAirportsChange: () => {
    },
};
const Injected = (0, react_intl_1.injectIntl)(FlightConfig);
exports.FlightConfig = Injected;
//# sourceMappingURL=index.js.map